import Phaser from 'phaser';
import SpritePool from '../common/SpritePool';
import Bubble from './Bubble';

export default class BubbleColumns extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.columns = null;

    this.bubblePool = null;
    this.activeBubbles = null;

    this.columns = [];

    // Just hard code our 2 for now
    let c = {};
    c.xMin = 33;
    c.xMax = 87;
    c.waiter = 0;
    c.waitTime = 0.4;
    this.columns.push(c);

    c = {};
    c.xMin = 837;
    c.xMax = 883;
    c.waiter = 0;
    c.waitTime = 0.4;
    this.columns.push(c);

    this.bubblePool = new SpritePool(this.scene, Bubble, 200);
    this.activeBubbles = [];
  }

  makeBubble (colIndex) {
    const c = this.columns[colIndex];
    const item = this.bubblePool.getSprite();
    if (item === null) return;
    const scale = Phaser.Math.Between(10,100) / 100;
    const speed = Phaser.Math.Between(80,140);
    item.reset(Phaser.Math.Between(c.xMin, c.xMax), this.scene.scale.height + 20, scale, speed);
    this.add(item);
    this.activeBubbles.push(item);
  }

  returnBubble (i) {
    this.remove(this.activeBubbles[i]);
    this.bubblePool.returnSprite(this.activeBubbles[i]);
    this.activeBubbles.splice(i,1);
  }

  tick (delta) {
    let len = this.activeBubbles.length - 1; let item = null;
    for (let i = len; i >= 0; i--) {
      item = this.activeBubbles[i];
      if (item.y < 0) {
        this.returnBubble(i);
      }
      else {
        item.tick(delta);
      }
    }

    len = this.columns.length;
    for (let c = 0; c < len; c++) {
      if (this.columns[c].waiter < 0) {
        this.makeBubble(c);
        this.columns[c].waitTime = Phaser.Math.Between(2,8) / 10;
        this.columns[c].waiter = this.columns[c].waitTime;
      }
      else {
        this.columns[c].waiter -= 1 * delta;
      }
    }
  }
}